import React from 'react';
import PropTypes from 'prop-types';
import ASearchTag from '../atoms/_atoms.search-tag';

export default function MTagList({ items, onClick }) {
	let tags = <p>alles</p>;

	const handleClick = ({ id }) => {
		if (onClick) {
			onClick(id);
		}
	};

	if (items.length) {
		tags = items.map((item) => {
			return (
				<ASearchTag
					id={item.id}
					key={item.id}
					name={item.name}
					onClick={(id) => { handleClick(id); }}
				/>
			);
		});
	}

	return (
		<article className="m-tag-list">
			<p><span>Toon:</span></p>
			{tags}
		</article>
	);
}

MTagList.propTypes = {
	items: PropTypes.array.isRequired,
	onClick: PropTypes.func,
};

MTagList.defaultProps = {
	onClick: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.tag-list.js